import { Card, CardBody, CardHeader, Table } from "reactstrap";

import './calendario.scss'
import { estiloPrioridade } from "services/Utils";
import { useNavigate } from "react-router-dom";
import React from "react";

export default function Calendario({ dados }) {
  const navigate = useNavigate()

  return (
    <Card className="mt-4">
      <CardBody>
        <h2 className="text-center">Execuções agendadas</h2>
        <div className="calendario">
          <div className="linha header">
            <div className="data fds">Dom</div>
            <div className="data">Seg</div>
            <div className="data">Ter</div>
            <div className="data">Qua</div>
            <div className="data">Qui</div>
            <div className="data">Sex</div>
            <div className="data fds">Sab</div>
          </div>
          {dados.semanas.map((semana, idx) => (
            <div className="linha" key={idx}>
              {semana.map(dia => (
                <Data key={dia.data} dia={dia} navigate={navigate} />
              ))}
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  )
}

function Data({ dia, navigate }) {
  return (
    <div className={["data", dia.fds ? 'fds' : '', dia.passado ? 'passado' : ''].join(' ')}>
      <span>{dia.data}</span>
      {dia.execucoes.map(el => (
        <React.Fragment key={el.id}>
          <div className="os" style={{ ...estiloPrioridade(el.prioridade, false) }} onClick={() => navigate('/admin/ordens_servico/' + el.id.toString()) }>
            OS {el.numeroFmt}<br />
            {el.numencProjeto}<br />
            {el.equipe}
          </div>
        </React.Fragment>
      ))}
      {dia.execucoes.length == 0 && (
        <div className="na">
          Nada agendado
        </div>
      )}
    </div>
  )
}